import React from 'react';
import { Card, CardContent } from '../ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export const VisitFilters = ({
  filterStatus,
  filterEmployee,
  employees,
  onStatusChange,
  onEmployeeChange,
}) => (
  <Card className="border-slate-200">
    <CardContent className="pt-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <Select
          value={filterStatus || 'all'}
          onValueChange={(val) => onStatusChange(val === 'all' ? '' : val)}
        >
          <SelectTrigger className="w-full sm:w-48" data-testid="evv-status-filter">
            <SelectValue placeholder="All Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="Pending">Pending</SelectItem>
            <SelectItem value="Validated">Validated</SelectItem>
            <SelectItem value="Exception">Exception</SelectItem>
          </SelectContent>
        </Select>
        <Select
          value={filterEmployee || 'all'}
          onValueChange={(val) => onEmployeeChange(val === 'all' ? '' : val)}
        >
          <SelectTrigger className="w-full sm:w-56" data-testid="evv-employee-filter">
            <SelectValue placeholder="All Employees" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Employees</SelectItem>
            {employees.map((emp) => (
              <SelectItem key={emp.id} value={emp.id}>
                {emp.first_name} {emp.last_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </CardContent>
  </Card>
);
